import { SERVICES_INCLUDE } from "@/data/content";

export const ServicesInclude = () => {
  return (
    <section id="services" data-testid="services-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-16">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#e02329] mb-3">What We Do</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#1c4f9c]">
            A complete range of commercial cleaning services
          </h2>
          <p className="mt-4 text-base text-slate-600 leading-relaxed">
            Customized cleaning programs tailored to each facility's needs — delivered by trained professionals using industry-leading equipment.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
          {SERVICES_INCLUDE.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className="group bg-white p-8 hover:bg-[#1c4f9c] transition-colors duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#1c4f9c]/10 text-[#1c4f9c] rounded-sm mb-5 group-hover:bg-white/15 group-hover:text-white transition-colors duration-300">
                  <Icon size={24} strokeWidth={1.75} />
                </div>
                <h3 className="text-lg font-bold text-[#1c4f9c] group-hover:text-white transition-colors duration-300">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-600 group-hover:text-blue-100 leading-relaxed transition-colors duration-300">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
